(function () {
  const COMP_QTY_ERROR_DURATION = 2500;

  function resolveCompQtyErrorEl(from) {
    const card =
      from?.closest?.('.complementary-product-card') ||
      (from?.matches?.('.complementary-product-card') ? from : null);
    return card?.querySelector('[data-comp-qty-error]') || null;
  }

  function getCompQtyWrap(card) {
    return card?.querySelector('[data-comp-qty-wrap]');
  }

  function isCompCardSoldOut(card) {
    if (!card) return false;
    if (card.hasAttribute('data-comp-sold-out-card')) return true;
    if (card.querySelector('[data-comp-sold-out]:not([hidden])')) return true;

    const wrap = getCompQtyWrap(card);
    const inventoryMax = wrap?.dataset.inventoryMax ? parseInt(wrap.dataset.inventoryMax, 10) : null;
    return inventoryMax !== null && !Number.isNaN(inventoryMax) && inventoryMax <= 0;
  }

  function applyCompSoldOutButtonState(button, card) {
    if (!button || !isCompCardSoldOut(card)) return false;

    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('disabled');
    if (button.matches('.complementary-quick-add__submit, [type="submit"]')) {
      button.classList.add('complementary-quick-add__submit--sold-out');
    }
    return true;
  }

  function getPackQtyFromDom(wrap, card) {
    const variantId = wrap?.dataset?.variantId;
    const composer = window.__activePackComposer;
    if (composer && variantId && typeof composer.getPackQtyForVariant === 'function') {
      return composer.getPackQtyForVariant(variantId);
    }

    const addWrap = card?.querySelector('[data-comp-add-wrap]');
    if (addWrap && !addWrap.classList.contains('hidden')) {
      return 0;
    }

    const valueNode = wrap?.querySelector('[data-comp-qty-value]');
    return parseInt(valueNode?.value || '0', 10) || 0;
  }

  function getCompBlockReasonFromDom(wrap, card, { forAddButton = false } = {}) {
    if (!wrap || isCompCardSoldOut(card)) return null;

    const variantId = wrap.dataset.variantId;
    if (!variantId) return null;

    const composer = window.__activePackComposer;
    if (composer) {
      if (forAddButton && typeof composer.getAddBlockReason === 'function') {
        return composer.getAddBlockReason(variantId, wrap);
      }
      if (!forAddButton && typeof composer.getIncrementBlockReason === 'function') {
        return composer.getIncrementBlockReason(variantId, wrap);
      }
    }

    const inventoryMax = wrap.dataset.inventoryMax ? parseInt(wrap.dataset.inventoryMax, 10) : null;
    const cartQty = parseInt(wrap.dataset.cartQuantity || '0', 10);
    const packQty = getPackQtyFromDom(wrap, card);

    if (forAddButton) {
      if (inventoryMax !== null && !Number.isNaN(inventoryMax) && inventoryMax <= 0) return null;
      if (inventoryMax !== null && !Number.isNaN(inventoryMax) && cartQty >= inventoryMax) {
        return 'cart-max';
      }
      return null;
    }

    if (inventoryMax !== null && !Number.isNaN(inventoryMax) && inventoryMax <= 0) return null;

    if (inventoryMax !== null && !Number.isNaN(inventoryMax)) {
      if (cartQty >= inventoryMax) return 'cart-max';
      if (packQty >= inventoryMax - cartQty) return 'stock-max';
    }

    return null;
  }

  function inferCompBlockReasonFromDom(wrap, card) {
    if (isCompCardSoldOut(card)) return null;

    const inventoryMax = wrap?.dataset.inventoryMax ? parseInt(wrap.dataset.inventoryMax, 10) : null;
    const cartQty = parseInt(wrap?.dataset.cartQuantity || '0', 10);
    const packQty = getPackQtyFromDom(wrap, card);

    if (inventoryMax !== null && !Number.isNaN(inventoryMax)) {
      if (cartQty >= inventoryMax) return 'cart-max';
      if (packQty >= inventoryMax - cartQty) return 'stock-max';
    }

    return null;
  }

  function showCompProductQtyError(card, reason) {
    if (!card) return;
    const errorEl = resolveCompQtyErrorEl(card);
    if (!errorEl) return;

    const wrap = getCompQtyWrap(card);
    let message = '';
    if (reason === 'cart-max') {
      message = window.cartStrings?.cartMaxInCart || 'Quantité maximale dans le panier';
    } else {
      const stockQty = wrap?.dataset.inventoryMax || wrap?.querySelector('[data-comp-qty-value]')?.max || '';
      message =
        window.cartStrings?.maxStockError?.replace('[quantity]', stockQty) ||
        `${stockQty} en stock`.trim() ||
        'Quantité maximale atteinte';
    }

    errorEl.textContent = message;
    errorEl.removeAttribute('hidden');

    const timerHost = card;
    clearTimeout(timerHost.__compQtyErrorTimer);
    timerHost.__compQtyErrorTimer = window.setTimeout(() => {
      errorEl.setAttribute('hidden', '');
      errorEl.textContent = '';
      timerHost.__compQtyErrorTimer = null;
    }, COMP_QTY_ERROR_DURATION);
  }

  function isCompQtyButtonBlocked(button) {
    if (!button) return false;
    return (
      button.getAttribute('aria-disabled') === 'true' ||
      button.classList.contains('disabled') ||
      button.hasAttribute('disabled')
    );
  }

  function unlockPackCompQtyButtons(root = document) {
    root
      .querySelectorAll(
        '.complementary-products--pack-source [data-comp-qty-plus], .complementary-products--pack-source [data-comp-qty-minus], .complementary-products--pack-source [data-comp-add-wrap] .complementary-quick-add__submit, .complementary-products--pack-source [data-comp-add-wrap] button[type="submit"]'
      )
      .forEach((button) => {
        const card = button.closest('.complementary-product-card');
        if (applyCompSoldOutButtonState(button, card)) return;
        button.classList.remove('complementary-quick-add__submit--sold-out');
        button.removeAttribute('disabled');
      });
  }

  function installComplementaryQtyErrorHandlers() {
    if (window.__compQtyErrorHandlersInstalled) return;
    window.__compQtyErrorHandlersInstalled = true;

    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest('.complementary-products--pack-source')) return;

        const plusBtn = event.target.closest('[data-comp-qty-plus]');
        const addBtn = event.target.closest(
          '[data-comp-add-wrap] .complementary-quick-add__submit, [data-comp-add-wrap] button[type="submit"]'
        );
        if (!plusBtn && !addBtn) return;

        const card = event.target.closest('.complementary-product-card');
        const wrap = getCompQtyWrap(card);
        if (!card || !wrap) return;

        if (isCompCardSoldOut(card)) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          return;
        }

        const blockedBtn = plusBtn || addBtn;
        let reason = null;

        if (plusBtn) {
          reason = getCompBlockReasonFromDom(wrap, card, { forAddButton: false });
          if (!reason && isCompQtyButtonBlocked(blockedBtn)) {
            reason = inferCompBlockReasonFromDom(wrap, card);
          }
        } else if (addBtn) {
          reason = getCompBlockReasonFromDom(wrap, card, { forAddButton: true });
        }

        if (!reason) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        showCompProductQtyError(card, reason);
      },
      true
    );
  }

  installComplementaryQtyErrorHandlers();
  unlockPackCompQtyButtons();
  document.addEventListener('product-recommendations:loaded', () => unlockPackCompQtyButtons());

  class PackComposer extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.activeVariant = null;
      this.variantChangeUnsub = null;
      this.cartUpdateUnsub = null;
      this.cartQuantitiesByVariant = {};
      this.cartLineKeyByVariant = {};
      this.rootClickHandler = null;
      this.compQtyErrorDuration = 2500;
      this.footer = null;
      this.footerSpacer = null;
      this.footerSpacerActive = false;
      this.footerSpacerHeight = 0;
      this.footerSpacerScrollRaf = 0;
      this.footerSpacerScrollHandler = null;
      this.footerSpacerResizeHandler = null;
      this.footerSpacerResizeObserver = null;
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.root = document.querySelector(`#MainProductPackComposer-${this.sectionId}`) || document;
      const variantsNode = this.querySelector('[data-pack-composer-variants]');
      if (!variantsNode) return;

      const parsedVariants = JSON.parse(variantsNode.textContent || '[]');
      this.variants = parsedVariants
        .filter((variant) => Number(variant.capacity) > 0)
        .sort((a, b) => Number(a.capacity) - Number(b.capacity));
      if (!this.variants.length) {
        this.variants = parsedVariants
          .map((variant, index) => ({
            ...variant,
            capacity: Number(variant.capacity) > 0 ? Number(variant.capacity) : index + 1,
          }))
          .sort((a, b) => Number(a.capacity) - Number(b.capacity));
      }
      if (!this.variants.length) return;

      this.maxCapacity = Number(this.variants[this.variants.length - 1].capacity) || 0;
      this.lockIconUrl = this.dataset.lockIconUrl || '';
      this.closeIconUrl = this.dataset.closeIconUrl || '';
      this.closeIconMarkup = '';

      this.slotsNode = this.querySelector('[data-pack-composer-slots]');
      this.slotsNav = this.querySelector('[data-pack-composer-slots-nav]');
      this.slotsPrev = this.querySelector('[data-pack-composer-slots-prev]');
      this.slotsNext = this.querySelector('[data-pack-composer-slots-next]');
      this.maxMessageNode = this.querySelector('[data-pack-composer-max-message]');
      this.addButton = this.querySelector('[data-pack-composer-submit]');

      this.bindSlotsNavigation();
      this.installGlobalSubmitInterceptor();
      this.variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      this.cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));

      this.bindEvents();
      this.bindComplementaryQtyCapture();
      this.onSlotsLayoutChange = () => this.updateSlotsOverflowClass();
      this.slotsLayoutMedia = window.matchMedia('(max-width: 989px)');
      this.slotsLayoutMedia.addEventListener('change', this.onSlotsLayoutChange);
      this.bootstrapActiveVariant();
      this.render();
      void this.loadCloseIcon().then(() => this.render());
      unlockPackCompQtyButtons(this.root);
      this.fetchCartState();
      this.bindFooterSpacer();

      window.__activePackComposer = this;
    }

    disconnectedCallback() {
      this.variantChangeUnsub?.();
      this.cartUpdateUnsub?.();
      this.slotsLayoutMedia?.removeEventListener('change', this.onSlotsLayoutChange);
      if (this.slotsNode && this.slotsScrollHandler) {
        this.slotsNode.removeEventListener('scroll', this.slotsScrollHandler);
      }
      if (this.rootClickHandler) this.root.removeEventListener('click', this.rootClickHandler);
      this.unbindFooterSpacer();
      if (window.__activePackComposer === this) window.__activePackComposer = null;
    }

    bindFooterSpacer() {
      this.footer = document.querySelector('footer.footer');
      if (!this.footer) return;

      this.footerSpacer = document.createElement('div');
      this.footerSpacer.className = 'pack-composer-footer-spacer';
      this.footerSpacer.style.display = 'block';
      this.footerSpacer.setAttribute('aria-hidden', 'true');
      this.footer.insertAdjacentElement('afterend', this.footerSpacer);

      this.footerSpacerScrollHandler = () => {
        if (this.footerSpacerScrollRaf) return;
        this.footerSpacerScrollRaf = window.requestAnimationFrame(() => {
          this.footerSpacerScrollRaf = 0;
          this.syncFooterSpacer();
        });
      };

      this.footerSpacerResizeHandler = () => {
        this.measureFooterSpacer();
      };

      window.addEventListener('scroll', this.footerSpacerScrollHandler, { passive: true });
      window.addEventListener('resize', this.footerSpacerResizeHandler, { passive: true });
      window.visualViewport?.addEventListener('resize', this.footerSpacerResizeHandler, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        this.footerSpacerResizeObserver = new ResizeObserver(() => this.measureFooterSpacer());
        this.footerSpacerResizeObserver.observe(this);
      }

      this.measureFooterSpacer();
      this.syncFooterSpacer();
    }

    unbindFooterSpacer() {
      if (this.footerSpacerScrollHandler) {
        window.removeEventListener('scroll', this.footerSpacerScrollHandler);
      }
      if (this.footerSpacerResizeHandler) {
        window.removeEventListener('resize', this.footerSpacerResizeHandler);
        window.visualViewport?.removeEventListener('resize', this.footerSpacerResizeHandler);
      }
      this.footerSpacerResizeObserver?.disconnect();
      if (this.footerSpacerScrollRaf) {
        window.cancelAnimationFrame(this.footerSpacerScrollRaf);
        this.footerSpacerScrollRaf = 0;
      }
      this.footerSpacer?.remove();
      this.footer = null;
      this.footerSpacer = null;
      this.footerSpacerActive = false;
      this.footerSpacerScrollHandler = null;
      this.footerSpacerResizeHandler = null;
      this.footerSpacerResizeObserver = null;
    }

    measureFooterSpacer() {
      this.footerSpacerHeight = Math.ceil(this.getBoundingClientRect().height);
      if (this.footerSpacerActive && this.footerSpacer) {
        this.footerSpacer.style.height = `${this.footerSpacerHeight}px`;
      }
    }

    syncFooterSpacer() {
      if (!this.footer || !this.footerSpacer) return;

      const footerTop = this.footer.getBoundingClientRect().top;
      const reached = footerTop < window.innerHeight;

      if (reached !== this.footerSpacerActive) {
        this.footerSpacerActive = reached;
        if (!reached) {
          this.footerSpacer.style.height = '0px';
          return;
        }
      }

      if (!reached) return;

      this.measureFooterSpacer();
    }

    bindEvents() {
      this.rootClickHandler = (event) => {
        const removeButton = event.target.closest('[data-pack-remove-index]');
        if (removeButton && this.contains(removeButton)) {
          const index = Number(removeButton.getAttribute('data-pack-remove-index'));
          if (!Number.isNaN(index)) {
            this.items.splice(index, 1);
            this.render();
          }
          return;
        }

        if (event.target.closest('[data-pack-composer-submit]') && this.contains(event.target.closest('[data-pack-composer-submit]'))) {
          this.submitPack();
          return;
        }

        const packAddButton = event.target.closest(
          '.complementary-products--pack-source [data-comp-add-wrap] .complementary-quick-add__submit, .complementary-products--pack-source [data-comp-add-wrap] button[type="submit"]'
        );
        if (packAddButton) {
          const card = packAddButton.closest('.complementary-product-card');
          const wrap = card?.querySelector('[data-comp-qty-wrap]');
          if (isCompCardSoldOut(card)) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
            return;
          }
          const variantId =
            wrap?.dataset.variantId || card?.querySelector('input[name="id"]')?.value;
          if (variantId) {
            const reason = this.getAddBlockReason(variantId, wrap);
            if (reason) {
              event.preventDefault();
              event.stopPropagation();
              if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
              this.showCompQtyError(card || wrap, reason);
              return;
            }
          }
          if (!this.canAddMoreToPack()) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          }
          return;
        }

        if (event.target.closest('[data-comp-qty-plus]')) {
          const wrap = event.target.closest('[data-comp-qty-wrap]');
          const variantId = wrap?.dataset.variantId;
          if (variantId) this.incrementComplementaryQty(variantId, wrap);
          return;
        }

        if (event.target.closest('[data-comp-qty-minus]')) {
          const wrap = event.target.closest('[data-comp-qty-wrap]');
          const variantId = wrap?.dataset.variantId;
          if (variantId) this.decrementComplementaryQty(variantId, wrap);
        }
      };
      this.root.addEventListener('click', this.rootClickHandler);
    }

    bindComplementaryQtyCapture() {
      this.compQtyCaptureHandler = (event) => {
        const plusBtn = event.target.closest('.complementary-products--pack-source [data-comp-qty-plus]');
        const addBtn = event.target.closest(
          '.complementary-products--pack-source [data-comp-add-wrap] .complementary-quick-add__submit, .complementary-products--pack-source [data-comp-add-wrap] button[type="submit"]'
        );
        if (!plusBtn && !addBtn) return;

        const card = event.target.closest('.complementary-product-card');
        const wrap = card?.querySelector('[data-comp-qty-wrap]');
        const variantId = wrap?.dataset.variantId || card?.querySelector('input[name="id"]')?.value;
        if (!variantId) return;

        if (isCompCardSoldOut(card)) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          return;
        }

        if (addBtn) {
          const reason = this.getAddBlockReason(variantId, wrap);
          if (reason) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
            this.showCompQtyError(card || wrap, reason);
          }
          return;
        }

        const reason = this.getIncrementBlockReason(variantId, wrap);
        if (reason) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          this.showCompQtyError(card || wrap, reason);
          return;
        }

        if (!this.canAddMoreToPack()) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        }
      };
      this.root.addEventListener('click', this.compQtyCaptureHandler, true);
    }

    installGlobalSubmitInterceptor() {
      if (window.__packComposerSubmitInterceptorInstalled) return;
      window.__packComposerSubmitInterceptorInstalled = true;

      document.addEventListener(
        'submit',
        (event) => {
          const activeComposer = window.__activePackComposer;
          if (!activeComposer) return;
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (!form.closest('.complementary-products--pack-source')) return;

          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          activeComposer.addComplementaryFormItem(form);
        },
        true
      );
    }

    bootstrapActiveVariant() {
      const selectedByMetafield = this.variants.find((variant) => variant.selected_by_metafield === true);
      const id = this.root.querySelector(`#product-form-${this.sectionId} input[name="id"]`)?.value;
      const selectedByForm = this.variants.find((variant) => String(variant.id) === String(id));

      this.activeVariant = selectedByMetafield || selectedByForm || this.variants[0];
      this.applyVariantToUI();

      if (selectedByMetafield) {
        this.syncPickerWithVariant();
      }
    }

    onVariantChange(event) {
      const { sectionId, variant } = event.data || {};
      if (!variant || String(sectionId) !== String(this.sectionId)) return;

      const match = this.variants.find((v) => String(v.id) === String(variant.id));
      if (!match) return;

      const count = this.items.length;
      if (count > Number(match.capacity)) {
        const upgraded =
          this.variants.find((v) => Number(v.capacity) >= count) || this.variants[this.variants.length - 1];
        this.activeVariant = upgraded;
        this.syncPickerWithVariant();
        return;
      }

      this.activeVariant = match;
      this.applyVariantToUI();
      this.render();
    }

    getActivePackCapacity() {
      return Math.max(0, Number(this.activeVariant?.capacity) || 0);
    }

    canAddMoreToPack() {
      const activeCapacity = this.getActivePackCapacity();
      return activeCapacity > 0 && this.items.length < activeCapacity;
    }

    addComplementaryFormItem(form) {
      const card = form.closest('.complementary-product-card');
      const wrap = card?.querySelector('[data-comp-qty-wrap]');
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || variantInput.disabled) return;

      const variantId = String(variantInput.value);
      const reason = this.getAddBlockReason(variantId, wrap);
      if (reason) {
        this.showCompQtyError(card || wrap, reason);
        return;
      }
      if (!this.canIncrementVariant(variantId, wrap)) return;

      const title = card?.querySelector('.complementary-product-card__title a')?.textContent?.trim() || 'Capsule';
      const image = card?.querySelector('.complementary-product-card__img')?.getAttribute('src') || '';
      const productId = String(card?.dataset?.compProductId || '');

      this.items.push({
        variantId,
        productId,
        title,
        image,
      });

      this.render();
    }

    getPackQtyForVariant(variantId) {
      return this.items.reduce((count, item) => {
        return String(item.variantId) === String(variantId) ? count + 1 : count;
      }, 0);
    }

    getCardDataForVariant(variantId) {
      const variantInput = Array.from(this.root.querySelectorAll('.complementary-product-card input[name="id"]')).find(
        (input) => String(input.value) === String(variantId)
      );
      const card = variantInput?.closest('.complementary-product-card');
      const title = card?.querySelector('.complementary-product-card__title a')?.textContent?.trim() || 'Capsule';
      const image = card?.querySelector('.complementary-product-card__img')?.getAttribute('src') || '';
      const productId = String(card?.dataset?.compProductId || '');
      return { variantId: String(variantId), productId, title, image };
    }

    getWrapInventoryMax(wrap) {
      if (!wrap?.dataset?.inventoryMax) return null;
      const value = parseInt(wrap.dataset.inventoryMax, 10);
      return Number.isNaN(value) ? null : value;
    }

    getWrapCartQty(variantId) {
      return this.cartQuantitiesByVariant[String(variantId)] || 0;
    }

    getMaxPackQtyForVariant(variantId, wrap) {
      const inventoryMax = this.getWrapInventoryMax(wrap);
      if (inventoryMax === null) return Number.POSITIVE_INFINITY;
      return Math.max(0, inventoryMax - this.getWrapCartQty(variantId));
    }

    getRemainingPackSlots() {
      const activeCapacity = this.getActivePackCapacity();
      if (activeCapacity <= 0) return Number.POSITIVE_INFINITY;
      return Math.max(0, activeCapacity - this.items.length);
    }

    getSlotMaxPackQty(variantId) {
      const packQty = this.getPackQtyForVariant(variantId);
      const remainingSlots = this.getRemainingPackSlots();
      if (!Number.isFinite(remainingSlots)) return Number.POSITIVE_INFINITY;
      return packQty + remainingSlots;
    }

    getEffectiveMaxPackQty(variantId, wrap) {
      const stockMax = this.getMaxPackQtyForVariant(variantId, wrap);
      const slotMax = this.getSlotMaxPackQty(variantId);
      return Math.min(stockMax, slotMax);
    }

    canIncrementVariant(variantId, wrap) {
      if (!this.canAddMoreToPack()) return false;
      const packQty = this.getPackQtyForVariant(variantId);
      return packQty < this.getEffectiveMaxPackQty(variantId, wrap);
    }

    getAddBlockReason(variantId, wrap) {
      if (!wrap) return null;

      const packQty = this.getPackQtyForVariant(variantId);
      if (packQty > 0) return null;

      const inventoryMax = this.getWrapInventoryMax(wrap);
      if (inventoryMax !== null && inventoryMax <= 0) return null;
      const cartQty = this.getWrapCartQty(variantId);
      if (inventoryMax !== null && cartQty >= inventoryMax) return 'cart-max';

      return null;
    }

    getIncrementBlockReason(variantId, wrap) {
      if (!wrap) return null;
      const inventoryMax = this.getWrapInventoryMax(wrap);
      if (inventoryMax !== null && inventoryMax <= 0) return null;
      const cartQty = this.getWrapCartQty(variantId);
      const packQty = this.getPackQtyForVariant(variantId);

      if (inventoryMax !== null) {
        if (cartQty >= inventoryMax) return 'cart-max';
        if (packQty >= inventoryMax - cartQty) return 'stock-max';
      }

      return null;
    }

    showCompQtyError(context, reason) {
      const card =
        context?.closest?.('.complementary-product-card') ||
        (context?.matches?.('.complementary-product-card') ? context : null);
      showCompProductQtyError(card, reason);
    }

    hideCompQtyError(context) {
      const errorEl = resolveCompQtyErrorEl(context);
      if (!errorEl) return;
      const card = errorEl.closest('.complementary-product-card');
      clearTimeout(card?.__compQtyErrorTimer);
      if (card) card.__compQtyErrorTimer = null;
      errorEl.setAttribute('hidden', '');
      errorEl.textContent = '';
    }

    incrementComplementaryQty(variantId, wrap) {
      wrap =
        wrap ||
        this.root.querySelector(`[data-comp-qty-wrap][data-variant-id="${String(variantId)}"]`);

      const reason = this.getIncrementBlockReason(variantId, wrap);
      if (reason) {
        this.showCompQtyError(wrap?.closest('.complementary-product-card') || wrap, reason);
        return;
      }

      const packQty = this.getPackQtyForVariant(variantId);
      if (packQty > 0 || window.__activePackComposer === this) {
        if (!this.canIncrementVariant(variantId, wrap)) return;
        const item = this.getCardDataForVariant(variantId);
        this.items.push(item);
        this.render();
        return;
      }

      this.updateCartVariantQuantity(variantId, (this.cartQuantitiesByVariant[String(variantId)] || 0) + 1);
    }

    decrementComplementaryQty(variantId, wrap) {
      wrap =
        wrap ||
        this.root.querySelector(`[data-comp-qty-wrap][data-variant-id="${String(variantId)}"]`);
      this.hideCompQtyError(wrap);

      const packQty = this.getPackQtyForVariant(variantId);
      if (packQty > 0) {
        const idx = this.items.map((item) => String(item.variantId)).lastIndexOf(String(variantId));
        if (idx > -1) this.items.splice(idx, 1);
        this.render();
        return;
      }

      const cartQty = this.cartQuantitiesByVariant[String(variantId)] || 0;
      if (cartQty > 0) this.updateCartVariantQuantity(variantId, cartQty - 1);
    }

    refreshComplementaryQtyUI() {
      this.root.querySelectorAll('[data-comp-qty-wrap]').forEach((qtyWrap) => {
        const variantId = String(qtyWrap.dataset.variantId || '');
        const productId = String(qtyWrap.dataset.productId || '');
        const addWrap = qtyWrap.parentElement?.querySelector('[data-comp-add-wrap]');
        const card = qtyWrap.closest('.complementary-product-card');
        if (!addWrap) return;

        const soldOut = isCompCardSoldOut(card);

        const cartQty = variantId ? this.getWrapCartQty(variantId) : 0;
        qtyWrap.dataset.cartQuantity = String(cartQty);
        const inventoryMax = this.getWrapInventoryMax(qtyWrap);

        let packQty = variantId ? this.getPackQtyForVariant(variantId) : 0;
        if (packQty === 0 && productId) {
          packQty = this.items.reduce((count, item) => {
            return String(item.productId || '') === productId ? count + 1 : count;
          }, 0);
        }
        const displayedQty = packQty;
        const valueNode = qtyWrap.querySelector('[data-comp-qty-value]');
        const effectiveMax = this.getEffectiveMaxPackQty(variantId, qtyWrap);
        const isPackFull = this.getActivePackCapacity() > 0 && this.getRemainingPackSlots() <= 0;
        const canIncrement = this.canIncrementVariant(variantId, qtyWrap);
        if (valueNode) {
          const nextValue = String(Math.max(1, displayedQty || 1));
          valueNode.dataset.cartQuantity = String(cartQty);
          if (inventoryMax !== null) {
            valueNode.dataset.max = String(inventoryMax);
          } else {
            valueNode.removeAttribute('data-max');
          }
          if ('value' in valueNode) {
            valueNode.value = nextValue;
            if (Number.isFinite(effectiveMax) && effectiveMax > 0) {
              valueNode.setAttribute('max', String(effectiveMax));
            } else {
              valueNode.removeAttribute('max');
            }
          } else {
            valueNode.textContent = nextValue;
          }
        }

        const plusBtn = qtyWrap.querySelector('[data-comp-qty-plus]');
        if (plusBtn) {
          if (soldOut) {
            applyCompSoldOutButtonState(plusBtn, card);
          } else {
            plusBtn.classList.toggle('disabled', !canIncrement);
            plusBtn.setAttribute('aria-disabled', String(!canIncrement));
            plusBtn.removeAttribute('disabled');
          }
        }

        const minusBtn = qtyWrap.querySelector('[data-comp-qty-minus]');
        if (minusBtn) {
          if (soldOut) {
            applyCompSoldOutButtonState(minusBtn, card);
          } else if (displayedQty > 0) {
            minusBtn.classList.remove('disabled');
            minusBtn.removeAttribute('disabled');
            minusBtn.removeAttribute('aria-disabled');
          }
        }

        const addSubmit = addWrap?.querySelector('.complementary-quick-add__submit, button[type="submit"]');
        if (addSubmit) {
          if (soldOut) {
            applyCompSoldOutButtonState(addSubmit, card);
          } else {
            const canAddFirst = canIncrement && !isPackFull;
            addSubmit.classList.toggle('disabled', !canAddFirst);
            addSubmit.setAttribute('aria-disabled', String(!canAddFirst));
            addSubmit.classList.remove('complementary-quick-add__submit--sold-out');
            addSubmit.removeAttribute('disabled');
          }
        }

        const quantityInput = qtyWrap.querySelector('quantity-input');
        if (quantityInput && typeof quantityInput.validateQtyRules === 'function') {
          quantityInput.validateQtyRules();
        }

        unlockPackCompQtyButtons(qtyWrap.parentElement || this.root);

        if (displayedQty > 0) {
          addWrap.classList.add('hidden');
          qtyWrap.classList.remove('hidden');
        } else {
          addWrap.classList.remove('hidden');
          qtyWrap.classList.add('hidden');
        }
      });
    }

    onCartUpdate(event) {
      const cartData = event?.cartData || event?.data?.cartData;
      if (cartData && Array.isArray(cartData.items)) {
        const qtyMap = {};
        const keyMap = {};
        cartData.items.forEach((item) => {
          const id = String(item.variant_id || '');
          if (!id) return;
          qtyMap[id] = (qtyMap[id] || 0) + Number(item.quantity || 0);
          keyMap[id] = item.key || keyMap[id];
        });
        this.cartQuantitiesByVariant = qtyMap;
        this.cartLineKeyByVariant = keyMap;
        this.refreshComplementaryQtyUI();
        return;
      }

      this.fetchCartState();
    }

    fetchCartState() {
      fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then((response) => response.json())
        .then((cartData) => this.onCartUpdate({ cartData }))
        .catch(() => {});
    }

    updateCartVariantQuantity(variantId, quantity) {
      const currentLineKey = this.cartLineKeyByVariant[String(variantId)];
      const endpoint = currentLineKey ? '/cart/change.js' : '/cart/add.js';
      const payload = currentLineKey
        ? { id: currentLineKey, quantity: Math.max(0, quantity) }
        : { id: Number(variantId), quantity: Math.max(1, quantity) };

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(() => fetch('/cart.js', { headers: { Accept: 'application/json' } }))
        .then((response) => response.json())
        .then((cartData) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pack-composer',
            cartData,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }

    applyVariantToUI() {
      if (!this.activeVariant) return;
      const titleNode = this.root.querySelector('[data-pack-main-title]');
      const priceNode = this.root.querySelector('[data-pack-main-price]');
      const mainVariantIdInput = this.root.querySelector(`#product-form-${this.sectionId} input[name="id"]`);

      if (titleNode) titleNode.textContent = this.activeVariant.display_title || this.activeVariant.title;
      if (priceNode) priceNode.textContent = this.activeVariant.price_formatted || '';
      if (mainVariantIdInput) {
        mainVariantIdInput.value = String(this.activeVariant.id);
        mainVariantIdInput.disabled = false;
      }
    }

    syncPickerWithVariant() {
      const variantSelects = this.root.querySelector('variant-selects');
      if (!variantSelects || !Array.isArray(this.activeVariant.options)) return;

      const groups = variantSelects.querySelectorAll('fieldset.product-form__input');
      let lastTouched = null;

      groups.forEach((group, index) => {
        const optionValue = this.activeVariant.options[index];
        if (!optionValue) return;
        const wantedInput = Array.from(group.querySelectorAll('input[type="radio"]')).find(
          (input) => String(input.value) === String(optionValue)
        );
        if (wantedInput && !wantedInput.checked) {
          wantedInput.checked = true;
          lastTouched = wantedInput;
        }
      });

      if (lastTouched) {
        const previousScrollY = window.scrollY || window.pageYOffset || 0;
        window.__suppressVariantTargetFocus = true;
        window.__suppressMediaGalleryAutoScroll = true;
        lastTouched.dispatchEvent(new Event('change', { bubbles: true }));
        requestAnimationFrame(() => {
          window.scrollTo({ top: previousScrollY, left: 0, behavior: 'auto' });
        });
        window.setTimeout(() => {
          window.scrollTo({ top: previousScrollY, left: 0, behavior: 'auto' });
        }, 80);
        window.setTimeout(() => {
          window.__suppressVariantTargetFocus = false;
          window.__suppressMediaGalleryAutoScroll = false;
        }, 300);
      } else {
        this.applyVariantToUI();
      }
    }

    getSlotsVisibleLimit() {
      return window.matchMedia('(max-width: 989px)').matches ? 4 : 8;
    }

    bindSlotsNavigation() {
      this.slotsPrev?.addEventListener('click', () => this.scrollSlots('prev'));
      this.slotsNext?.addEventListener('click', () => this.scrollSlots('next'));

      if (!this.slotsNode) return;

      this.slotsScrollHandler = () => this.updateSlotsNavState();
      this.slotsNode.addEventListener('scroll', this.slotsScrollHandler, { passive: true });
    }

    getSlotsScrollStep() {
      const firstSlot = this.slotsNode?.querySelector('.pack-composer__slot');
      if (!firstSlot) return 0;

      const gap = parseFloat(getComputedStyle(this.slotsNode).columnGap || getComputedStyle(this.slotsNode).gap) || 0;
      return firstSlot.offsetWidth + gap;
    }

    scrollSlots(direction) {
      if (!this.slotsNode) return;

      const step = this.getSlotsScrollStep();
      if (!step) return;

      const delta = direction === 'next' ? step : -step;
      this.slotsNode.scrollTo({
        left: this.slotsNode.scrollLeft + delta,
        behavior: 'smooth',
      });
    }

    updateSlotsNavState() {
      if (!this.slotsNav || !this.slotsNode) return;

      const hasOverflow = this.slotsNode.classList.contains('pack-composer__slots--overflow');
      this.slotsNav.hidden = !hasOverflow;

      if (!hasOverflow) return;

      const maxScroll = this.slotsNode.scrollWidth - this.slotsNode.clientWidth;
      const scrollLeft = this.slotsNode.scrollLeft;

      if (this.slotsPrev) {
        if (scrollLeft <= 1) this.slotsPrev.setAttribute('disabled', 'disabled');
        else this.slotsPrev.removeAttribute('disabled');
      }

      if (this.slotsNext) {
        if (scrollLeft >= maxScroll - 1) this.slotsNext.setAttribute('disabled', 'disabled');
        else this.slotsNext.removeAttribute('disabled');
      }
    }

    updateSlotsOverflowClass() {
      if (!this.slotsNode) return;
      const activeCapacity = Math.max(0, Number(this.activeVariant?.capacity) || 0);
      const hasOverflow = activeCapacity > this.getSlotsVisibleLimit();
      this.slotsNode.classList.toggle('pack-composer__slots--overflow', hasOverflow);

      if (!hasOverflow) {
        this.slotsNode.scrollLeft = 0;
      }

      this.updateSlotsNavState();
    }

    prepareCloseIconMarkup(svgText) {
      const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
      const svg = doc.querySelector('svg');
      if (!svg) return '';

      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');

      svg.querySelectorAll('[fill]').forEach((node) => {
        if (node.getAttribute('fill') !== 'none') {
          node.setAttribute('fill', 'currentColor');
        }
      });

      return svg.outerHTML;
    }

    async loadCloseIcon() {
      if (!this.closeIconUrl || this.closeIconMarkup) return;

      try {
        const response = await fetch(this.closeIconUrl);
        if (!response.ok) return;

        const svgText = await response.text();
        this.closeIconMarkup = this.prepareCloseIconMarkup(svgText);
      } catch (_error) {
        this.closeIconMarkup = '';
      }
    }

    getRemoveIconMarkup() {
      if (this.closeIconMarkup) {
        return `<span class="pack-composer__remove-icon" aria-hidden="true">${this.closeIconMarkup}</span>`;
      }

      return '&times;';
    }

    renderSlots() {
      if (!this.slotsNode) return;
      const nodes = [];
      const activeCapacity = Math.max(0, Number(this.activeVariant?.capacity) || 0);
      this.updateSlotsOverflowClass();

      for (let index = 0; index < activeCapacity; index += 1) {
        const item = this.items[index];

        if (item) {
          const title = item.title.replace(/"/g, '&quot;');
          const imageTag = item.image ? `<img src="${item.image}" alt="${title}">` : '';
          const removeIcon = this.getRemoveIconMarkup();
          nodes.push(
            `<div class="pack-composer__slot is-filled">${imageTag}<button class="pack-composer__remove" type="button" data-pack-remove-index="${index}" aria-label="Retirer ${title}">${removeIcon}</button></div>`
          );
          continue;
        }

        nodes.push(
          '<div class="pack-composer__slot pack-composer__slot--empty" role="img" aria-label="Emplacement libre"></div>'
        );
      }
      this.slotsNode.innerHTML = nodes.join('');
      requestAnimationFrame(() => this.updateSlotsNavState());
    }

    render() {
      this.renderSlots();
      const activeCapacity = Number(this.activeVariant?.capacity) || 0;
      const isPackComplete = activeCapacity > 0 && this.items.length >= activeCapacity;
      const isVariantAvailable = this.activeVariant?.available !== false;
      if (this.maxMessageNode) {
        this.maxMessageNode.hidden = true;
      }
      if (this.addButton) this.addButton.disabled = !this.activeVariant || !isVariantAvailable || !isPackComplete;
      this.refreshComplementaryQtyUI();
      this.measureFooterSpacer();
    }

    submitPack() {
      const activeCapacity = Number(this.activeVariant?.capacity) || 0;
      const isPackComplete = activeCapacity > 0 && this.items.length >= activeCapacity;
      if (!this.activeVariant || this.activeVariant.available === false || !isPackComplete) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const compositionByTitle = this.items.reduce((acc, item) => {
        const title = String(item.title || '').trim();
        if (!title) return acc;
        acc[title] = (acc[title] || 0) + 1;
        return acc;
      }, {});
      const composition = Object.entries(compositionByTitle)
        .map(([title, count]) => `${count} x ${title}`)
        .join(', ');
      const payload = {
        items: [
          {
            id: this.activeVariant.id,
            quantity: 1,
            properties: {
              _pack_composer: 'true',
              'Pack composition': composition,
            },
          },
        ],
      };

      if (cartDrawer) {
        const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      const cartAddUrl =
        typeof routes !== 'undefined' && routes.cart_add_url
          ? routes.cart_add_url.includes('.js')
            ? routes.cart_add_url
            : `${routes.cart_add_url}.js`
          : '/cart/add.js';

      this.addButton?.setAttribute('disabled', 'disabled');
      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'pack-composer',
              productVariantId: String(this.activeVariant.id),
              errors: response.errors || response.description,
              message: response.message,
            });
            console.error(response.description || response.message || 'Cannot add pack');
            return;
          }

          if (!cartDrawer) {
            window.location.href = typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url : '/cart';
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pack-composer',
            productVariantId: String(this.activeVariant.id),
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });

          CartPerformance.measure('add:paint-updated-sections', () => {
            cartDrawer.renderContents(response);
          });

          if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          this.fetchCartState();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.addButton?.removeAttribute('disabled');
        });
    }
  }

  if (!customElements.get('pack-composer')) {
    customElements.define('pack-composer', PackComposer);
  }
})();
